// MARK://dhk8/admin-shell/lib/queries/purchase-orders
// Queries tipadas de órdenes de compra — F2.3 / ADR-0009. El Admin lee POs por el
// grafo (erp-purchase-orders), tenant del JWT (RLS). Escrituras siguen REST.
import { graphql } from '../../gql/index.js'

export const AdminPurchaseOrdersQuery = graphql(`
  query AdminPurchaseOrders($limit: Int) {
    purchaseOrders(limit: $limit) {
      items {
        id
        tenantId
        networkId
        supplierId
        status
        totalCents
        notes
        archived
        createdAt
        updatedAt
        lines {
          id
          poId
          productId
          description
          qty
          uom
          unitCents
          totalCents
          receivedQty
        }
      }
    }
  }
`)

export const AdminPurchaseOrderQuery = graphql(`
  query AdminPurchaseOrder($id: ID!) {
    purchaseOrder(id: $id) {
      id
      tenantId
      networkId
      supplierId
      status
      totalCents
      notes
      archived
      createdAt
      updatedAt
      lines {
        id
        poId
        productId
        description
        qty
        uom
        unitCents
        totalCents
        receivedQty
      }
      receipts {
        id
        poId
        receivedCents
        balanceCents
        notes
        receivedAt
      }
    }
  }
`)


// ── F8.x: escrituras de OC por el grafo (erp-purchase-orders, tenant del JWT, RLS) ──
export const AdminCreatePurchaseOrderMutation = graphql(`
  mutation AdminCreatePurchaseOrder($input: ErpPoCreateInput!) {
    createPurchaseOrder(input: $input) {
      id
      status
      totalCents
    }
  }
`)

export const AdminUpdatePurchaseOrderMutation = graphql(`
  mutation AdminUpdatePurchaseOrder($id: ID!, $input: ErpPurchaseOrderUpdateInput!) {
    updatePurchaseOrder(id: $id, input: $input) {
      id
      supplierId
      status
      totalCents
      notes
      lines {
        id
        poId
        productId
        description
        qty
        uom
        unitCents
        totalCents
        receivedQty
      }
    }
  }
`)

export const AdminReceivePurchaseOrderMutation = graphql(`
  mutation AdminReceivePurchaseOrder($id: ID!, $receivedCents: Int!, $notes: String) {
    receivePurchaseOrder(id: $id, receivedCents: $receivedCents, notes: $notes) {
      id
      status
    }
  }
`)

export const AdminCancelPurchaseOrderMutation = graphql(`
  mutation AdminCancelPurchaseOrder($id: ID!, $reason: String) {
    cancelPurchaseOrder(id: $id, reason: $reason) {
      id
      status
    }
  }
`)

// F6.2 R3c: submit/approve de OC por el grafo (IDOR-guard por RLS, sin permiso
// RBAC declarado en el servicio — la ruta REST tampoco lo exige).
export const AdminSubmitPurchaseOrderMutation = graphql(`
  mutation AdminSubmitPurchaseOrder($id: ID!) {
    submitPurchaseOrder(id: $id) {
      id
      status
    }
  }
`)

export const AdminApprovePurchaseOrderMutation = graphql(`
  mutation AdminApprovePurchaseOrder($id: ID!, $approvedBy: String!) {
    approvePurchaseOrder(id: $id, approvedBy: $approvedBy) {
      id
      status
    }
  }
`)
